import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
    theme: {

        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        alert: {
            padding: GlobalTokens.SpacingInsetSizeXs,
            boxShadow: `${GlobalTokens.ShadowLevel1} ${hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelSemitransparent)}`,
            borderRadius: GlobalTokens.BorderRadiusMd,
            types: {
              error: {
                backgroundColor: BrandTokens.FeedbackColorErrorLight,
                color: BrandTokens.FeedbackColorErrorDark
              },
              success: {
                backgroundColor: BrandTokens.FeedbackColorSuccessLight,
                color: BrandTokens.FeedbackColorSuccessDark
              }
            }
          },
          title:{
            paddingBottom: GlobalTokens.SpacingSizeNano,
            text: {
              padding: `0 ${GlobalTokens.SpacingSizeXxxs}`
            },
            button: {
              states:{
                hover: {
                  backgroundColor: BrandTokens.NeutralColorHighPure
                }
              }
            }
          },
          message:{
            paddingLeft: GlobalTokens.SpacingSizeSm
          },
          link: {
            paddingTop: GlobalTokens.SpacingSizeXxxs
          }
      }
}